export default __webpack_public_path__ + "static/media/tch.411983db.png";